export enum $successCriteria {
  handle = 'handle',
  level = 'level',
  num = 'num',
  title = 'title',
  versions = 'versions',
  url = 'url',
  standard = 'standard',
}
